import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=89150088"
import script from "./HotelList.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HotelList.vue?vue&type=style&index=0&id=89150088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports